import { render, staticRenderFns } from "./PageWechatIndex.vue?vue&type=template&id=21882620&scoped=true"
import script from "./PageWechatIndex.vue?vue&type=script&lang=js"
export * from "./PageWechatIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21882620",
  null
  
)

export default component.exports